// helper/tokenExpiry.js
import { auth } from './Utility';

let logoutTimer = null;

export const scheduleAutoLogout = (logoutCallback) => {
  // Clear any existing timer first
  if (logoutTimer) clearTimeout(logoutTimer);

  const authData = auth('admin');
  if (!authData?.token) return;

  try {
    // Decode JWT payload without any library
    const payload = JSON.parse(atob(authData.token.split('.')[1]));
    const expiresAt = payload.exp * 1000; // convert seconds → ms
    const timeout = expiresAt - Date.now();

    if (timeout <= 0) {
      // Token already expired
      logoutCallback();
      return;
    }

    logoutTimer = setTimeout(() => {
      logoutCallback();
    }, timeout);

  } catch (e) {
    console.error('Failed to schedule auto logout:', e);
  }
};

export const clearAutoLogout = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
};
